var video_viewer_default = {
  "video_player": "J24qL",
  "videoOverlay": "ytMu8",
  "video_container": "_-7msT"
};
export {
  video_viewer_default as default
};
//# sourceMappingURL=video-viewer-scss.js.map
